function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref = /*#__PURE__*/React.createElement("title", null, "cancel-letter");

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20.04,
    height: 20.04,
    viewBox: "0 0 20.04 20.04"
  }, props), _ref, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M10,20A10,10,0,1,1,20,10,10,10,0,0,1,10,20ZM10,2a8,8,0,1,0,8,8A8.05,8.05,0,0,0,10,2Z",
    style: {
      "fill": "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10,8.53l1.9-3.27h2.65L11.31,10l3.32,4.81H12l-2-3.34-2,3.34H5.41L8.73,10,5.51,5.26H8.12Z",
    style: {
      "fill": "#fff"
    }
  })));
};

export default __webpack_public_path__ + "static/media/cancel-letter.200bcd7c.svg";
export { SvgComponent as ReactComponent };